module.exports = __webpack_public_path__ + "img/mockup_goodstore@2x.99a1bbb5.png";